

export const splitCompanyRegistration = (data) => {
    let prefix = "";
    let number = "";
    if (data !== ""){
        const result = data.match(/([A-Za-z]*)([0-9]*)/);
        prefix = result[1].toLowerCase();
        number = result[2];
    }
    return {prefix, number};
}

export default splitCompanyRegistration;